import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getActionTypeFromInstance, NgxsPlugin } from '@ngxs/store';
import { FetchEventSearchesFiltersForGame, GameVideoFetchGameContext, GameVideoFetchPlayerEvents } from '@sportlogiq/main/game-video/game-video.actions';
import { FetchAdvancedStatEvents } from '@sportlogiq/main/statistics/advanced-stats/advanced-stats.actions';
import { FetchEventSearchesFiltersForLeagueSeason, SeasonVideoFetchContext, SeasonVideoFetchPlayerEvents } from '@sportlogiq/main/teams/season-video/store/season-video.actions';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    DeleteEventSearches,
    EditEventSearch,
    FetchEventSearches,
    SaveEventSearch,
} from '../../store/event-searches/event-searches.actions';
import { SlSnackBarComponent } from '@sportlogiq/shared/sl-snack-bar/sl-snack-bar.component';
import { SlSnackBarType } from '@sportlogiq/shared/sl-snack-bar/sl-snack-bar.types';

@Injectable()
export class ErrorHandlerPlugin implements NgxsPlugin {
    constructor(private _snackBar: MatSnackBar) {}

    handle(state, action, next) {
        const actionTypesForErrorSnackbar = {
            [SaveEventSearch.type]: 'An error occurred while trying to save.',
            [DeleteEventSearches.type]: 'An error occurred while trying to delete.',
            [EditEventSearch.type]: 'An error occurred while trying to edit.',
            [FetchEventSearches.type]: 'An error occurred while trying to load searches.',
            [GameVideoFetchGameContext.type]: 'Unable to load game details. Please try again.',
            [GameVideoFetchPlayerEvents.type]: 'An error occurred. Please try again!',
            [SeasonVideoFetchPlayerEvents.type]: 'An error occurred. Please try again!',
            [SeasonVideoFetchContext.type]: 'Unable to load season details. Please try again.',
            [FetchAdvancedStatEvents.type]: 'An error occurred while trying to fetch clips.',
            [FetchEventSearchesFiltersForGame.type]: 'An error occurred while trying to fetch event searches for game.',
            [FetchEventSearchesFiltersForLeagueSeason.type]: 'An error occurred while trying to fetch event searches for league',
        };

        if (actionTypesForErrorSnackbar[getActionTypeFromInstance(action)]) {
            return next(state, action).pipe(
                catchError(err => {
                    const snackBarRef = this._snackBar.openFromComponent(SlSnackBarComponent);
                    snackBarRef.instance.type = SlSnackBarType.ERROR;
                    snackBarRef.instance.matSnackBarRef = snackBarRef;
                    snackBarRef.instance.message = actionTypesForErrorSnackbar[getActionTypeFromInstance(action)];

                    return throwError(err);
                })
            );
        }

        return next(state, action);
    }
}
